import { render, staticRenderFns } from "./net-reviews-product-reviews.component.vue?vue&type=template&id=81604a60&"
import script from "./net-reviews-product-reviews.component.vue?vue&type=script&lang=ts&"
export * from "./net-reviews-product-reviews.component.vue?vue&type=script&lang=ts&"
import style0 from "./net-reviews-product-reviews.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "net-reviews-product-reviews.component.vue"
export default component.exports